// extracted by mini-css-extract-plugin
export default {"productDescription":"K_-z","featuredDescription":"L_-z","description":"M_-z","more":"N_-z","descriptionSku":"O_-z"};